import React, { useMemo } from 'react';
import { getIcon } from '../../utils/helpers/icons';
import { availableActionAdvancedIcons } from '../../utils/available-icons';

type ActionAdvancedIconProps = {
  iconName: string;
};

export const ActionAdvancedIcon: React.FC<ActionAdvancedIconProps> = ({ iconName }) => {
  const AdvancedIcon = useMemo(() => {
    const icon = getIcon(availableActionAdvancedIcons, iconName);
    if (icon) return icon.component;

    return availableActionAdvancedIcons[0].component;
  }, [iconName]);

  return AdvancedIcon;
};
